import { Dimensions } from "react-native";

const { height } = Dimensions.get("window");

const heightPercent = (percent: number) => {
  return (percent / 100) * height;
};

export default heightPercent;
